import React, {ReactElement} from 'react';
import {Box} from '@mui/material';
import Workspace from './Workspace.component';
import WorkspaceUpdated from './Workspace.component.updated';

/**
 * Wrapper component to toggle between legacy and new Explorer implementations.
 * Toggle is available via Help menu > "Toggle New/Legacy Explorer"
 *
 * REMOVAL INSTRUCTIONS (when new explorer is fully production-ready):
 * 1. Delete this file (WorkspaceToggleWrapper.tsx)
 * 2. Update workspace.page.tsx to import Workspace.component.updated directly
 * 3. Delete Workspace.component.tsx (legacy version)
 * 4. Rename Workspace.component.updated.tsx to Workspace.component.tsx
 */

// localStorage key for explorer preference
export const EXPLORER_STORAGE_KEY = 'isam.explorer.useNew';

// Helper to get current explorer preference (default: true = new explorer)
export function getUseNewExplorer(): boolean {
    const saved = localStorage.getItem(EXPLORER_STORAGE_KEY);
    // Default to true (new explorer) if no preference saved
    return saved !== 'false';
}

// Helper to toggle explorer preference
export function toggleExplorer(): void {
    const current = getUseNewExplorer();
    localStorage.setItem(EXPLORER_STORAGE_KEY, (!current).toString());
    // Reload to apply the change
    window.location.reload();
}

export default function WorkspaceToggleWrapper(): ReactElement {
    const useNewExplorer = getUseNewExplorer();

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gridColumn: '1 / -1',
            width: '100%',
            height: '100%'
        }}>
            <Box sx={{ flex: 1, overflow: 'hidden' }}>
                {useNewExplorer ? <WorkspaceUpdated /> : <Workspace />}
            </Box>
        </Box>
    );
}